import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { RegistrationClient } from "../../parentApi";

export default new RegistrationClient(app_uri, axiosClient());
